// One player is created only after its own thumbnail is activated.
if (!customElements.get('bw-short-player')) {
  customElements.define('bw-short-player', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.addEventListener('click', (event) => {
        const button = event.target.closest('.bw-short-play');
        if (!button || this.querySelector('iframe')) return;
        const id = this.dataset.videoId;
        if (!/^[\w-]{11}$/.test(id)) return; // Keep the ordinary YouTube link as fallback.
        const frame = document.createElement('iframe');
        frame.title = this.dataset.videoTitle || 'YouTube video';
        frame.src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&playsinline=1';
        frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        frame.allowFullscreen = true;
        frame.setAttribute('tabindex', '0');
        button.replaceWith(frame);
        frame.focus();
      });
    }
  });
}
